/**
 * Vite shim for next/link — portal components from xs-auth-react import it.
 */
import { Link as RouterLink } from "react-router-dom";

export default function Link({ href, children, className, ...rest }) {
  return (
    <RouterLink to={href ?? "/"} className={className} {...rest}>
      {children}
    </RouterLink>
  );
}
